import BinahScanFlow from ".";

export default function BinahScanFlowExamples() {
  return <BinahScanFlow onCompletedFlow={() => {}} />;
}
